import {AnalyticsBaseOrderDto} from "../../../common/models/core/analytics-base-order-dto";
import {BookingType} from "../../../../../models/payment/booking-type";


// Todo find out how to extend a enum
export enum CombinedOrderElementDtoKeys {
  eventId = 'eventId',
  interval = 'interval',
  orderCount = 'orderCount',
  revenue = 'revenue',
  revenueAfterTax = 'revenueAfterTax',
  locationId = 'locationId',
  bookingType = 'bookingType',
  compositionTypeId = 'compositionTypeId',
}

export class CombinedOrderElementDto extends AnalyticsBaseOrderDto {
  eventId: string;
  interval: string;
  orderCount: number;
  revenue: number;
  revenueAfterTax: number = 0
  /** Cost of goods for this element; 0 until a view supplies source-detail data (#142). */
  sourceDetailsCost: number = 0

  constructor(eventId: string, interval: string, bookingType: BookingType, orderCount: number, revenue: number, locationId: string, compositionTypeId: string, dateOfEvent?: Date) {
    super(locationId, bookingType, compositionTypeId);
    this.eventId = eventId;
    this.interval = interval;
    this.orderCount = orderCount;
    this.revenue = revenue;
  }
}
